import React, { useEffect, useRef, useState } from 'react';

import { FontAwesomeIcon } from '@magoosh/lib/icons';

import { supportsDeviceSelection } from './audio_devices';

interface Props {
  onDeviceChange?: (deviceId: string) => void;
}

const BrowserInstructions = () => {
  return (
    <p className="small">
      To change your speaker, update the default audio output in your <strong>operating system sound settings</strong>.
    </p>
  );
};

export default (props: Props) => {
  const [outputDevices, setOutputDevices] = useState<MediaDeviceInfo[]>([]);
  const [selectedDeviceId, setSelectedDeviceId] = useState<string>('default');
  const testAudioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    if (!supportsDeviceSelection()) return;

    refreshDevices();
  }, []);

  const refreshDevices = () => {
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then(() => navigator.mediaDevices.enumerateDevices())
      .then((devices) => {
        const audioOutputs = devices.filter((d) => d.kind === 'audiooutput');
        setOutputDevices(audioOutputs);

        const saved = localStorage.getItem('audioOutputDeviceId');
        if (saved && audioOutputs.some((d) => d.deviceId === saved)) {
          handleDeviceChange(saved);
        }
      })
      .catch(() => {});
  };

  const handleDeviceChange = (deviceId: string) => {
    setSelectedDeviceId(deviceId);
    localStorage.setItem('audioOutputDeviceId', deviceId);
    props.onDeviceChange?.(deviceId);

    if (testAudioRef.current && 'setSinkId' in testAudioRef.current) {
      (testAudioRef.current as any).setSinkId(deviceId);
    }
  };

  return (
    <div className="d-flex flex-column gap-m">
      {
        supportsDeviceSelection() ? (
          
          <div className="d-flex flex-column gap-xs">
            <div className="align-items-center d-flex gap-xs small">
              Output Device
              <a onClick={refreshDevices} style={{ cursor: 'pointer' }}>
                <FontAwesomeIcon className="text-gray-light tiny" icon="refresh" />
              </a>
            </div>

            <select
              id="output-device-select"
              className="form-control"
              value={selectedDeviceId}
              onChange={(e) => handleDeviceChange(e.target.value)}
            >
              {
                (outputDevices || []).map((device) => (
                  <option key={device.deviceId} value={device.deviceId}>
                    {device.label || `Speaker ${device.deviceId.slice(0, 8)}`}
                  </option>
                ))
              }
            </select>
          </div>
        ) : (
          <BrowserInstructions />
        )
      }

      <div className="d-flex flex-column gap-xs">
        <div className="small">Test Your Audio Playback</div>
        <audio
          ref={testAudioRef}
          className="d-flex"
          controls
          src="https://d296n67kxwq0ge.cloudfront.net/audio_video/6d09a398b0391a84789a8d573991d2ecb7c19e0e-video-1116609/originals.mp3?2026"
        >
          Your browser does not support the audio element.
        </audio>
      </div>
    </div>
  );
};
